import { Component, Injector, Input, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { BaseComponent } from '../../base-component/base.component';
import { ChartHeaderData, chartFilters } from 'src/app/shared/interfaces';
import { ChartDateFilterPipe } from 'src/app/shared/pipes/chart-date-filter-pipe';

@Component({
  selector: 'app-chart-card-header-data',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ChartDateFilterPipe
  ],
  templateUrl: './chart-card-header-data.component.html',
  styleUrls: ['./chart-card-header-data.component.scss']
})
export class ChartCardHeaderDataComponent extends BaseComponent implements OnInit {
  @Input() headerData: ChartHeaderData[];
  @Input() filters: chartFilters;
  @Input() isPercentage: boolean;
  @Input() customLabelTemplate: TemplateRef<any>;

  constructor(injector: Injector) { 
    super([], injector);
  }

  ngOnInit(): void {
  }
}
